import { render, staticRenderFns } from "./expressSettingDialog.vue?vue&type=template&id=6675d30c&scoped=true&"
import script from "./expressSettingDialog.vue?vue&type=script&lang=js&"
export * from "./expressSettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./expressSettingDialog.vue?vue&type=style&index=0&id=6675d30c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675d30c",
  null
  
)

export default component.exports